import React, { useState, useEffect } from "react";
import SliderService from "../../services/SliderService";
import { motion } from "motion/react";

const ListSlider = () => {
  const [slider, setSlider] = useState([]);
  const [currentSlider, setCurrentSlider] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [searchTitle, setSearchTitle] = useState("");

  useEffect(() => {
    retrieveSlider();
  }, []);

  const retrieveSlider = () => {
    SliderService.getAll()
      .then((response) => {
        setSlider(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const setActiveSlider = (slider, index) => {
    setCurrentSlider(slider);
    setCurrentIndex(index);
  };

  const refreshList = () => {
    retrieveSlider();
    setCurrentSlider(null);
    setCurrentIndex(-1);
  };

  // console.log("Current Slider:"+JSON.stringify(currentSlider))

  return (
    <div className="pb-10  bg-slate-100 w-full">
      <div className="flex flex-row-2 w-full h-16 text-center relative gap-y-80">
        <h1 className="text-4xl lg:text-4xl font-semibold px-10 pt-10">
          {" "}
          Home Page Slider
        </h1>

        <button
          className="bg-blue-500 hover:bg-blue-400 text-white font-bold py-2 px-4 border-b-4 border-blue-700
      hover:border-blue-500 rounded  absolute top-10 right-0"
        >
          <a
            href={"/admin/slider/add"}
            className="lg:text-1xl"
          >
            Add New Slider
          </a>
        </button>
      </div>

      {slider &&
        slider.map((menuitem, index) => (
          <div
            className="m-10 relative grid grid-cols-2"
            key={index}
          >
            <motion.img
              initial={{ x: 100, opacity: 0 }}
              whileInView={{
                x: 0,
                opacity: 1,
                transition: {
                  delay: 0.5,
                  x: { type: "spring", stiffness: 60 },
                  opacity: { duration: 0.6 },
                  ease: "easeIn",
                },
              }}
              src={menuitem.image}
              alt=""
              className="w-full  object-cover "
            />

            <div className="p-10">
              <h6 className="text-slate-800 font-semibold">{menuitem.name}</h6>
              <p>{menuitem.label}</p>
              <a
                href={"/admin/slider/" + menuitem.id}
                className="z-10 relative top-4 p-1"
              >
                <button className="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded">
                  Edit
                </button>
              </a>
            </div>
          </div>
        ))}
    </div>
  );
};

export default ListSlider;
